import { useMemo } from "react";
import { useGetRole } from "../../../lib/hooks/getRole";
import { IOption } from "../../../types/Option";
import USER_ROLES from "../../../types/UserRoles";

export const useFormattedRoles = (
  roles: IOption[],
  selectedUserRole: string | null = null,
) => {
  const [role] = useGetRole();

  const formattedRoles = useMemo(() => {
    const adminRoles: IOption[] =
      !selectedUserRole || selectedUserRole !== USER_ROLES.PORTAL_USER
        ? roles.filter((item) => item.label !== USER_ROLES.PORTAL_USER)
        : roles;

    if (role === USER_ROLES.ADMIN) {
      return adminRoles.filter((item) => item.label !== USER_ROLES.SUPER_ADMIN);
    }

    return adminRoles;
  }, [selectedUserRole, roles, role]);

  return { formattedRoles };
};
